var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUiIconUtility16Other({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#F4F4F4",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.85 2.35a7.35 7.35 0 0 0-1.5 1.55l.8.6a6.63 6.63 0 0 1 1.3-1.35l-.6-.8zM2.3 6.15l-.95-.3A6.255 6.255 0 0 0 1 8h1a5.74 5.74 0 0 1 .3-1.85zm-.95 4.05a7.2 7.2 0 0 0 1 1.95l.8-.6A6.445 6.445 0 0 1 2.3 9.9l-.95.3zm2.55 3.45a7.2 7.2 0 0 0 1.95 1l.3-.95a6.445 6.445 0 0 1-1.65-.85l-.6.8zm1.95-12.3.3.95A5.74 5.74 0 0 1 8 2V1a6.255 6.255 0 0 0-2.15.35zm6.25 12.3a7.59 7.59 0 0 0 1.55-1.55l-.8-.6a5.765 5.765 0 0 1-1.35 1.35l.6.8zm1.6-3.8.95.3c.218-.697.335-1.42.35-2.15h-1a5.74 5.74 0 0 1-.3 1.85zm.9-4.05a7.2 7.2 0 0 0-1-1.95l-.8.6c.361.506.648 1.062.85 1.65l.95-.3zm-2.55-3.5a7.2 7.2 0 0 0-1.95-1l-.3.95a6.445 6.445 0 0 1 1.65.85l.6-.8zm-1.9 12.35-.3-.95A5.74 5.74 0 0 1 8 14v1a10.71 10.71 0 0 0 2.15-.35z",
    fill: "#E0E0E0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiIconUtility16Other);
export default __webpack_public_path__ + "static/media/ui-icon-utility-16-other.286bd392.svg";
export { ForwardRef as ReactComponent };